import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import { Table, Row, Col, Button, Input, Spinner } from "reactstrap";
import { Filter, DefaultColumnFilter } from "./filters";
import { useDispatch } from "react-redux";
import { showPopup } from "../../store/popup/actions";
import { getBudget_percentage } from "../../store/budget-percentage/actions";

const TableContainerBudget = ({
  columns,
  data,
  isGlobalFilter,
  isAddOrder,
  isAddTableWithoutBorderStrap,
  handleOrderClicks,
  isAddCustomer,
  isAddUsers,
  handleUserClicks,
  handleCustomerClicks,
  isAddTableBorderStrap,
  isAddInvoice,
  handleInvoiceClicks,
  isHowItWork,
  loading,
  setPage,
  page_number,
  total_pages,
  _setPageSize,
  page_size,
  setQuery,
  query,
  onBlur
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    setPageSize,
    
    
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: page_size > 10 ? page_size : 10,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  )
  const [rowI,setRowI] = useState('')
  const [ColumnI,setColumnI] = useState('')
  const [valueBudget,setValueBudget] = useState('')
    const [toggle,setToggle] = useState(false)
    const dispatch = useDispatch()
  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""
  }

  const onChangeInSelect = event => {
    _setPageSize(Number(event.target.value))
    setPageSize(Number(event.target.value))

  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    setPage(page)
  }

  const handleUpdateBudgetPercentage = async ({ceremony_name,id,budget_percentage}) => {
    const arr = data.filter(d=>d.ceremony_name ==  ceremony_name && d.id != id)
    const sum = arr.reduce(
      (accumulator, a) => accumulator + parseInt(a.budget_percentage),
      0)
      console.log(arr)
      console.log(parseInt(sum)+parseInt(budget_percentage))
      if(parseInt(sum)+parseInt(budget_percentage) > 100){
        dispatch(showPopup({title:'Some of percentage for each ceremony should be 100%',warning:true}))
      }else{
        await onBlur({id,budget_percentage});
        // dispatch(getBudget_percentage({is_active:1}))
        setValueBudget('');
        setToggle(false)
      }
  }
  return (
    <Fragment>
      <Row className="mb-3">
        {isGlobalFilter && (
          <GlobalFilter
          setQuery={setQuery}
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            query={query}
            setOffset={setPage}
          />
        )}
        {isAddUsers && (
          <Col sm={7}>
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="waves-effect waves-light mb-3 btn btn-success"
                onClick={handleUserClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add New
              </Button>
            </div>
          </Col>
        )}
        {isAddInvoice && (
          <Col sm={7}>
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="waves-effect waves-light mb-3 btn btn-success"
                onClick={handleInvoiceClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add Invoice
              </Button>
            </div>
          </Col>
        )}
        {isAddCustomer && (
          <Col sm={7}>
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="waves-effect waves-light mb-3 btn btn-success"
                onClick={handleCustomerClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add New Customer
              </Button>
            </div>
          </Col>
        )}
        {isHowItWork && (
          <Col sm={7}>
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="waves-effect waves-light mb-3 btn btn-success"
                onClick={handleCustomerClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add
              </Button>
            </div>
          </Col>
        )}
        {isAddOrder && (
          <Col sm={7}>
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="waves-effect waves-light mb-3 btn btn-success"
                onClick={handleOrderClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add New Order
              </Button>
            </div>
          </Col>
        )}

        <Col md={1}>
          <select
            className="form-select"
            value={page_size}
            onChange={onChangeInSelect}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
      </Row>

      {isAddTableWithoutBorderStrap && (
        <div className="table-responsive" style={{ minHeight: 260 }}>
          <Table bordered hover {...getTableProps()} className="react_table">
            {loading ? (
              <center>
                <Spinner type="grow" style={{ textAlign: "center" }} />
              </center>
            ) : (
              <>
                <thead className="table-nowrap">
                  {headerGroups.map(headerGroup => (
                    <tr
                      key={headerGroup.id}
                      {...headerGroup.getHeaderGroupProps()}
                    >
                      {headerGroup.headers.map(column => (
                        <th key={column.id}>
                          <div
                            className="mb-2"
                            {...column.getSortByToggleProps()}
                          >
                            {column.render("Header")}
                            {generateSortingIndicator(column)}
                          </div>
                          <Filter column={column} />
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {page.map(row => {

                    prepareRow(row)
                    return (
                      <Fragment key={row.getRowProps().key}>
                        <tr>
                          {row.cells.map((cell,i) => {
                            if(toggle && row.id == rowI && i == 2){
                              return (
                                <td key={cell.id} {...cell.getCellProps()} >
                                <input onChange={(e)=>setValueBudget(e.target.value)} onBlur={async (e)=>{
                                 handleUpdateBudgetPercentage({ceremony_name:cell.row.original.ceremony_name,id:cell.row.original.id,budget_percentage:valueBudget ? valueBudget : 0})
                                     
                                 
                                 
                                  }} value={valueBudget}/>
                                </td>
                              )
                            }else{
                                return (
                              <td onDoubleClick={()=>{setValueBudget(cell.row.original.budget_percentage); setToggle(true); i == 2 ? setRowI(row.id) : console.log('hi')}} key={cell.id} {...cell.getCellProps()} >
                                {cell.render("Cell")}
                              </td>
                            )
                            }
                          
                          })}
                        </tr>
                      </Fragment>
                    )
                  })}
                </tbody>
              </>
            )}
          </Table>
        </div>
      )}

      {isAddTableBorderStrap && (
        <div className="table-responsive">
          <Table
            className="table-centered datatable dt-responsive nowrap table-card-list react_table"
            {...getTableProps()}
          >
            {" "}
            {loading ? (
              <center>
                <Spinner type="grow" style={{ textAlign: "center" }} />
              </center>
            ) : (
              <>
                <thead className="table-nowrap">
                  {headerGroups.map(headerGroup => (
                    <tr
                      key={headerGroup.id}
                      {...headerGroup.getHeaderGroupProps()}
                    >
                      {headerGroup.headers.map(column => (
                        <th key={column.id}>
                          <div
                            className="mb-2"
                            {...column.getSortByToggleProps()}
                          >
                            {column.render("Header")}
                            {generateSortingIndicator(column)}
                          </div>
                          <Filter column={column} />
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {page.map(row => {
                    prepareRow(row)
                    return (
                      <Fragment key={row.getRowProps().key}>
                        <tr>
                          {row.cells.map(cell => {
                            return (
                              <td key={cell.id} {...cell.getCellProps()}>
                                {cell.render("Cell")}
                              </td>
                            )
                          })}
                        </tr>
                      </Fragment>
                    )
                  })}
                </tbody>
              </>
            )}
          </Table>
        </div>
      )}

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setPage(0)}
              disabled={page_number === 0 ? true : false}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              // onClick={previousPage}
              onClick={() => setPage(page_number - 1)}
              disabled={page_number === 0 ? true : false}
            >
              {"<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{" "}
          <strong>
            {page_number + 1} of {total_pages}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            max={total_pages}
            defaultValue={page_number + 1}
            onChange={onChangeInInput}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              // onClick={nextPage}
              onClick={() => setPage(page_number + 1)}
              disabled={page_number === total_pages - 1 ? true : false}
            >
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => setPage(total_pages  -  1)}
              disabled={total_pages === page_number + 1 ? true : false}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  setQuery,
  query,
  setOffset
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    // setGlobalFilter(value || undefined);
    setOffset(0)
    setQuery(value)
  }, 1);

  return (
    <React.Fragment>
      <Col sm={4}>
        <div className="search-box me-2 mb-2 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={(e) => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={`Search`}
                value={query || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
}

TableContainerBudget.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainerBudget;
